import * as DataLinks from "./DataLinks.js";
import * as TipoObjeto from "../../constantes/TipoObjeto.js";

export const DeleteItem = async (idPadre, idItem) => {
  return await DataLinks.DeleteItem(idPadre, idItem);
};

export const GetItem = async (idPadre, idItem) => {
  return DataLinks.GetItem(idPadre, idItem);
}

export const GetListaItems = async (idPadre) => {
  return DataLinks.GetListaItems("personas", idPadre);
}

export const PostItem = async (idPadre, datosItem) => {
  return await DataLinks.PostItem(TipoObjeto.PERSONA, idPadre, datosItem);
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataLinks.PutItem(TipoObjeto.PERSONA, idPadre, datosItem);
};
